
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.11 50.25l3.41-28.255c3.384-.132 6.09-2.929 6.09-6.345 0-3.5-2.85-6.35-6.35-6.35-3.163 0-5.796 2.328-6.273 5.36h-1.032L25.64 5.75c-.12-.44-.51-.75-.97-.75H19c-.55 0-1 .45-1 1s.45 1 1 1h4.9l1.995 7.66H22.76c-.29 0-.56.13-.75.34-.2.21-.28.5-.25.78l4.16 34.47L23 53.4c-.27.29-.34.72-.18 1.08.16.36.52.6.92.6h10.55c.4 0 .76-.24.92-.6.16-.36.09-.79-.18-1.08l-2.92-3.15zm-8.22-33.59l.492 4.073c1.88-.574 3.664-.17 4.928.227.215.066.43.139.648.212.146.05.293.1.442.148 1.08.375 2.528.87 3.103.622l.12-.995a1 1 0 01.024-.2l.493-4.087H23.89zm9.365 7.338a3.964 3.964 0 01-.125.002c-1.052 0-2.241-.404-3.354-.781l-.026-.009c-.35-.12-.7-.24-1.04-.35-1.659-.519-2.948-.553-4.084-.103L27.97 50.47c.04.29-.06.58-.26.8l-1.68 1.81H32l-1.68-1.81c-.2-.22-.29-.51-.26-.8l3.195-26.472zm6.355-8.348c0 2.233-1.681 4.07-3.846 4.321l.506-4.191c.03-.28-.06-.57-.25-.78a.98.98 0 00-.75-.34h-4.247a4.356 4.356 0 014.237-3.36c2.4 0 4.35 1.95 4.35 4.35z"}})])
          )
        }
      }
    